import {defineNuxtPlugin} from '#app'
import {HttpLink, from, ApolloLink} from '@apollo/client/core'
import {setContext} from '@apollo/client/link/context'
import {onError} from "@apollo/client/link/error"

export default defineNuxtPlugin(nuxtAppMain => {
  const runtimeConfig = useRuntimeConfig()

  const nuxtApp = useNuxtApp()

  const httpLink = new HttpLink({
    uri: import.meta.client ? runtimeConfig.public.apollo.browserHttpEndpoint : runtimeConfig.public.apollo.httpEndpoint || 'http://localhost:3000/graphql',
  })

  const userUuid = useCookie(runtimeConfig.public.uuidCookieName)

  const authLink = setContext((_, {headers}) => {
    return {
      headers: {
        ...headers,
        ...(userUuid.value && {
          'x-user-uuid': userUuid.value
        }),
        ...{
          isServer: import.meta.server,
          isClient: import.meta.client,
        }
      },
    }
  })

  const debugLink = new ApolloLink((operation, forward) => {
    // Called before operation is sent to server
    operation.setContext({ start: new Date() });

    return forward(operation).map((data) => {
      // Called after server responds
      // const time = (new Date()).getTime() - operation.getContext().start.getTime();
      //console.log('roundTripLink', JSON.stringify(operation.variables, undefined, 2))
      //console.log('roundTripLink DATA', data)
      // console.log(`Operation ${operation.operationName} took ${time} to complete`);
      return data;
    });
  });

  const errorLink = onError(({ graphQLErrors, networkError, response, operation }) => {
    // if (graphQLErrors)
    //   graphQLErrors.forEach(({ message, locations, path }) =>
    //     console.log(
    //       `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
    //     )
    //   );
    // if (networkError) console.error(`[Network error]: ${networkError}`, response);
    // console.log('CONTEXT', operation?.getContext().response.body)
  })

  nuxtApp.$apollo.defaultClient.setLink(from([errorLink.concat(debugLink.concat(authLink.concat(httpLink)))]));

  nuxtApp.hook('apollo:error', (error) => {
    console.log('APOLLO')
    console.error('apollo:error', error);
  });
})
